import { render, staticRenderFns } from "./WorkflowRunFormSimple.vue?vue&type=template&id=64878523&scoped=true&"
import script from "./WorkflowRunFormSimple.vue?vue&type=script&lang=js&"
export * from "./WorkflowRunFormSimple.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowRunFormSimple.vue?vue&type=style&index=0&id=64878523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64878523",
  null
  
)

export default component.exports